import {
  Checkbox,
  FormControlLabel,
  Radio,
  RadioGroup,
  FormControl,
  FormLabel,
  Button,
} from "@mui/material";
import { red } from "@mui/material/colors";
import { styled } from "@mui/material/styles";
import { useState } from "react";
import * as React from "react";
import Dialog from "@mui/material/Dialog";
import { useCookies } from "react-cookie";
import ReCAPTCHA from "react-google-recaptcha";
import axios from "axios";
import * as Yup from "yup";
import ErrorText from "../common/ErrorText";
import { useEffect } from "react";
import { useRef } from "react";
import CloseIcon from "@mui/icons-material/Close";
import styles from "../../Styles/modal.module.css";
import { useFormik } from "formik";
import apiCall from "../../helpers/apifactory";
import Select from "react-select";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

const BootstrapDialogTitle = (props) => {
  const { children, onClose, ...other } = props;
};

const OpenAccount = () => {
  useEffect(() => {
    let current_page = window.location.href.split("/").at(-1);
    setTimeout(() => {
      document
        .getElementById(`${current_page}`)
        ?.scrollIntoView({ block: "center", behavior: "smooth" });
    }, 100);
  });
  window.addEventListener(
    "scroll",
    function (event) {
      let top = this.scrollY,
        window_width = window.innerWidth,
        header_height = document.querySelector("header").style.height + 100;
      // (top > header_height && window_width > 1024) ? document.querySelector("nav").classNameList.add('fixed-header-desktop') : document.querySelector("nav").classNameList.remove('fixed-header-desktop')
      top > header_height && window_width > 1024
        ? document.querySelector("a").classList.add("fixed-header-desktop")
        : document.querySelector("a").classList.remove("fixed-header-desktop");
    },
    false
  );
  window.addEventListener(
    "scroll",
    function (event) {
      let top = this.scrollY,
        window_width = window.innerWidth,
        header_height = document.querySelector("header").style.height + 100;
      top > header_height && window_width > 1024
        ? document.querySelector("nav").classList.add("fixed-header-desktop")
        : document
            .querySelector("nav")
            .classList.remove("fixed-header-desktop");
      // (top > header_height && window_width > 1024) ? document.querySelector("a").classNameList.add('fixed-header-desktop') : document.querySelector("a").classNameList.remove('fixed-header-desktop')
    },
    false
  );
  const modalRef = useRef(null);
  const [show, setShow] = useState(false);
  const [open, setOpen] = React.useState(false);
  const [cities, setCities] = useState([]);
  const [originState, setOriginState] = useState("");
  const [newcities, setNewCities] = useState([]);

  const handleChange = (e) => {
    setOriginState(e.value);
  };

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    if (show) {
      modalRef.current.classList.add(styles.visible);
    } else {
      modalRef.current.classList.remove(styles.visible);
    }
  }, [show]);
  useEffect(() => {
    apiCall
      .getCity()
        .then((res) => {
            console.log("00000", res?.data?.responseData?.cities);
            setCities(res?.data?.responseData?.cities);
            var cityarr = res?.data?.responseData?.cities.map(
          ({ station_code, station_name }) => ({
            value: station_code,
            label: station_name,
          })
        );
        setNewCities(cityarr);
            setCities(res?.data?.responseData?.cities);
      })
      .catch((error) => {
        console.log("===============", error);
      });
  }, []);

  const formik = useFormik({
    initialValues: {
      bussinessType: "yes",
      compAccTitle: "",
      ownerName: "",
      cnic: "",
      ntn: "",
      city: "",
      location: "",
      pickAddress: "",
      compNum: "",
      mobNum: "",
      mobNum2: "",
      compEmail: "",
      facebook: false,
      whatsapp: false,
      website: false,
      instagram: false,
      other: false,
      bussinessName: "",
      bussinessNature: "",
      billAddress: "",
      salesTax: "",
      monthsInBussiness: "nill",
      avgShip: "nill",
      serialNum: "",
      name: "",
      designation: "",
      custMobNum: "",
      custEmail: "",
      custCNIC: "",
      prodRange: {},
      termCond: false,
      undertak: false,
      iban: "",
      bankName: "",
      branch: "",
      bankAcTitle: "",
      recaptcha: "",
    },
    validationSchema: Yup.object({
      compAccTitle: Yup.string().required("This is Required"),
      ownerName: Yup.string().required("This is Required"),
      cnic: Yup.string()
        .matches(/^[0-9+]{5}-[0-9+]{7}-[0-9]{1}$/, {
          message: "xxxxx-xxxxxxx-x",
          excludeEmptyString: false,
        })
        .required("This is Required"),
      ntn: Yup.string().required("This is Required"),
      city: Yup.string().required("This is Required"),
      location: Yup.string().required("This is Required"),
      pickAddress: Yup.string().required("This is Required"),
      compNum: Yup.string().required("This is Required"),
      mobNum: Yup.string()
        .matches(/^((\+92)?(0092)?(92)?(0)?)(3)([0-9]{9})$/gm, {
          message: "Invalid phone number",
          excludeEmptyString: false,
        })
        .required("This is Required"),
      mobNum2: Yup.string().matches(
        /^((\+92)?(0092)?(92)?(0)?)(3)([0-9]{9})$/gm,
        {
          message: "Invalid phone number",
          excludeEmptyString: false,
        }
      ),
      compEmail: Yup.string()
        .email("Invalid email address")
        .required("This is Required"),
      facebook: Yup.boolean(),
      whatsapp: Yup.boolean(),
      website: Yup.boolean(),
      instagram: Yup.boolean(),
      other: Yup.boolean(),
      bussinessName: Yup.string().required("This is Required"),
      bussinessNature: Yup.string().required("This is Required"),
      billAddress: Yup.string().required("This is Required"),
      salesTax: Yup.string().required("This is Required"),
      serialNum: Yup.string().required("This is Required"),
      name: Yup.string().required("This is Required"),
      designation: Yup.string().required("This is Required"),
      custMobNum: Yup.string()
        .matches(/^((\+92)?(0092)?(92)?(0)?)(3)([0-9]{9})$/gm, {
          message: "Invalid phone number",
          excludeEmptyString: false,
        })
        .required("This is Required"),
      custEmail: Yup.string()
        .email("Invalid email address")
        .required("This is Required"),
      custCNIC: Yup.string()
        .matches(/^[0-9+]{5}-[0-9+]{7}-[0-9]{1}$/, {
          message: "xxxxx-xxxxxxx-x",
          excludeEmptyString: false,
        })
        .required("This is Required"),
      prodRange: Yup.object().required("This is Required"),
      iban: Yup.string().required("This is Required"),
      bankName: Yup.string().required("This is Required"),
      branch: Yup.string().required("This is Required"),
      bankAcTitle: Yup.string().required("This is Required"),
      termCond: Yup.boolean()
        .required("Terms and conditions must be accepted.")
        .oneOf([true], "Terms and conditions must be accepted."),
      undertak: Yup.boolean()
        .required("Undertakings must be accepted.")
        .oneOf([true], "Undertakings must be accepted."),
      // recaptcha: Yup.string().required(),
    }),
    onSubmit: (values) => {
      const body = {
        toEmailID: "customerservices@tcs.com.pk",
        fromEmailID: "noreply@tcs.com.pk",
        emailSubject: values?.custEmail,
        emailText: `
            compAccTitle: ${values?.compAccTitle} \n
            ownerName: ${values?.ownerName} \n
            cnic: ${values?.cnic} \n
            ntn: ${values?.ntn} \n
            city: ${values?.city} \n
            location: ${values?.location} \n
            pickAddress: ${values?.pickAddress} \n
            compNum: ${values?.compNum} \n
            mobNum: ${values?.mobNum} \n
            mobNum2: ${values?.mobNum2} \n
            compEmail: ${values?.compEmail} \n
            facebook: ${values?.facebook} \n
            whatsapp: ${values?.whatsapp} \n
            website: ${values?.website} \n
            instagram: ${values?.instagram} \n
            other: ${values?.other} \n
            bussinessName: ${values?.bussinessName} \n
            bussinessNature: ${values?.bussinessNature} \n
            billAddress: ${values?.billAddress} \n
            salesTax: ${values?.salesTax} \n
            serialNum: ${values?.serialNum} \n
            name: ${values?.name} \n
            designation: ${values?.designation} \n
            custMobNum: ${values?.custMobNum} \n
            custEmail: ${values?.custEmail} \n
            custCNIC: ${values?.custCNIC} \n
            prodRange: ${values?.prodRange} \n
            termCond: ${values?.termCond} \n
            undertaking: ${values?.undertaking} \n
            iban: ${values?.iban} \n
            bankName: ${values?.bankName} \n
            branch: ${values?.branch} \n
            bankAcTitle: ${values?.bankAcTitle} \n
          `,
        cc: values?.custEmail,
        bcc: values?.custEmail,
        attachments: [],
        replyTo: values?.custEmail,
      };
      // const header = {
      //   Authorization: `Bearer ${'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJyb2xlIjpbIk5vdGlmaWNhdGlvbiIsIkludGVybmF0aW9uYWxCb29raW5nIiwiVHJhY2siLCJUVEMiLCJGU1AiLCJDbGFpbVNlcnZpY2UiLCJXTVMiLCJHU00iLCJSTVMiLCJXb3JrZmxvdyIsIkNMUyJdLCJjbGllbnRpZCI6IjIxMTExMTExMSIsImF1ZCI6WyJtaWRkbGV3YXJlLnRyYW56dW1way5jb20iLCJtaWRkbGV3YXJlLnRyYW56dW1way5jb20iXSwiaXNzIjoibWlkZGxld2FyZS50cmFuenVtcGsuY29tIiwianRpIjoiNjFmNzllZTgtMDZjNi00NmY0LWExM2MtNWUwOWZjODU4Mzg1IiwibmJmIjoxNjczMjc4MTU4LCJleHAiOjE3NTk2NzQ1NTgsImlhdCI6MTY3MzI3ODE1OH0.FVA0xgGz6BjVdbXglSR94to8oSTZEaMWxRVWTP8DC38'}`,
      // };
      apiCall
        .sendEmail(body, {})
        .then((res) => {
          setShow(true);
          formik.setValues(formik?.initialValues);
          formik.setTouched({}, false);
        })
        .catch((error) => {
          console.log("===============", error);
        });
    },
  });

  const handleProdChange = (e) => {
    if (e?.target?.checked)
      formik?.setFieldValue("prodRange", {
        ...formik?.values?.prodRange,
        [e?.target?.name]: true,
      });
    else
      formik?.setFieldValue("prodRange", {
        ...formik?.values?.prodRange,
        [e?.target?.name]: false,
      });
  };

  return (
    <div>
      <div className="bg-[#efefef] flex flex-col justify-center items-center h-[150px]">
        <h1 className="sm:text-[40px] text-[30px] font-bold">E-com Solutions</h1>
        <p className="text-[1.05rem] mt-[-5px]">Account Opening Form</p>
      </div>

      <div className="my-[3rem]">
        <div className="sm:flex block flex-col justify-center items-center mt-[1rem]">
          <div className="flex flex-col gap-3 p-8  shadow-card text-sm md:w-[45rem] sm:w-[40rem] w-[auto]  mx-[1rem] rounded-md transition-all duration-500">
            {/* <h2 className="font-bold text-[1.1rem]">Applicant Form</h2>
          <div className="sm:flex grid gap-4">
            <div className="MuiFormControl-root flex-1" inputprops="[object Object]" inputlabelprops="[object Object]">
              <div className="relative">
                <input
                  disabled={true}
                  value={prodType}
                  style={{ fontWeight: "bolder" }}
                  type="text" id="floating_outlined" className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer" placeholder=" " />
              </div>
            </div>
            <div className="MuiFormControl-root flex-1" inputprops="[object Object]" inputlabelprops="[object Object]">
              <div className="relative">
                <input
                  style={{ fontWeight: "bolder" }}
                  disabled={true}
                  value={subCat}
                  type="text" id="floating_outlined" className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer" placeholder=" " />
              </div>
            </div>
          </div> */}

            <h2 className="font-bold text-[1.1rem]">Business Type</h2>
            <div className="flex gap-4">
              <div className="flex-1 flex flex-col ">
                <div
                  className="MuiFormGroup-root rowflex"
                  role="radiogroup"
                  aria-label="bussinessType"
                >
                  <div className="flex">
                    <FormControl component="fieldset">
                      <FormLabel component="legend">
                        Is your Business a registered tax Payer
                      </FormLabel>
                      <RadioGroup
                        className="rowflex"
                        aria-labelledby="bussinessType"
                        name="bussinessType"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.bussinessType}
                      >
                        <FormControlLabel
                          value="yes"
                          control={
                            <Radio
                              sx={{
                                "&.Mui-checked": {
                                  color: red[600],
                                },
                              }}
                            />
                          }
                          label={<p className="text-sm">Yes </p>}
                        />

                        <FormControlLabel
                          value="no"
                          control={
                            <Radio
                              sx={{ "&.Mui-checked": { color: red[600] } }}
                            />
                          }
                          label={<p className="text-sm">No</p>}
                        />
                      </RadioGroup>
                    </FormControl>
                  </div>
                </div>
              </div>
            </div>
            <div className="flex gap-4">
              <div className="flex-1 flex flex-col"></div>
            </div>
          </div>
        </div>
        <div className="sm:flex block flex-col justify-center items-center mt-[1rem] ">
          <div className="flex flex-col gap-1 p-8 shadow-card text-sm md:w-[45rem] sm:w-[40rem] w-[auto] mx-[1rem] rounded-md transition-all duration-500 pt-0">
            <div className="flex gap-4 mt-4">
              <div className="flex-1 flex flex-col gap-1">
                <div className="sm:flex grid gap-4">
                  <div className="MuiFormControl-root MuiTextField-root flex-1">
                    <div className="relative">
                      <input
                        type="text"
                        id="floating_outlined"
                        className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                        placeholder=" "
                        name="compAccTitle"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.compAccTitle}
                      />
                      <label
                        for="floating_outlined"
                        className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                      >
                        Company Name/ Acc. Title
                      </label>
                    </div>
                    <ErrorText
                      text={
                        formik?.touched?.compAccTitle &&
                        formik?.errors?.compAccTitle
                      }
                    />
                  </div>

                  <div className="MuiFormControl-root MuiTextField-root flex-1">
                    <div className="relative">
                      <input
                        type="text"
                        id="floating_outlined"
                        className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                        placeholder=" "
                        name="ownerName"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.ownerName}
                      />
                      <label
                        for="floating_outlined"
                        className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                      >
                        Owner Name
                      </label>
                    </div>
                    <ErrorText
                      text={
                        formik?.touched?.ownerName && formik?.errors?.ownerName
                      }
                    />
                  </div>
                </div>
                <div className="sm:flex grid gap-4">
                  <div className="MuiFormControl-root MuiTextField-root flex-1">
                    <div className="relative">
                      <input
                        type="text"
                        id="floating_outlined"
                        className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                        placeholder=" "
                        name="cnic"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.cnic}
                      />
                      <label
                        for="floating_outlined"
                        className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                      >
                        CNIC Number*
                      </label>
                    </div>
                    <ErrorText
                      text={formik?.touched?.cnic && formik?.errors?.cnic}
                    />
                  </div>

                  <div className="MuiFormControl-root MuiTextField-root flex-1">
                    <div className="relative">
                      <input
                        type="number"
                        id="floating_outlined"
                        className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                        placeholder=" "
                        name="ntn"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.ntn}
                      />
                      <label
                        for="floating_outlined"
                        className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                      >
                        NTN number*
                      </label>
                    </div>
                    <ErrorText
                      text={formik?.touched?.ntn && formik?.errors?.ntn}
                    />
                  </div>
                </div>
                <div className="flex gap-4">
                  <div className="MuiFormControl-root flex-1">
                    <div className="relative">
                      {/* <select
                      id="floating_outline"
                      className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                      placeholder=" "
                      name="city"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.city}
                    >
                      <option>Please Select</option>
                      {
                        cities?.map((data, index) => (
                          <option key={index} value={data?.['station_code']}>
                            {data?.['station_name']}
                          </option>
                        ))
                      }
                    </select>

                    <label
                      for="floating_outlined"
                      className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                    >
                      City
                    </label> */}
                      {/* <input
                      list="data"
                      className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-black focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                      name="city"
                      placeholder="City"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      
                       
                      value={formik.values.city}
                      />
                      <datalist className="datalist w-[300px] bg-[white]" id="data">
                      <select
                        onChange={(e) => {
                          let result = cities.find(x => x.station_name===e.target.value).station_code;
                          // console.log(newcities, "cities");
                          // setOriginState(result);
                         
                         
                        }}
                      >
                      {cities?.map((data, index) => (
                          <option key={index} value={data?.["station_name"]}>
                            {data?.["station_name"]}
                          </option>
                        ))}
                      </select>
                    </datalist> */}
                      <Select
                        className="select1"
                        placeholder="Origin (city)"
                        name="from_City"
                        value={newcities.find(
                          (obj) => obj.value === originState
                        )}
                        options={newcities}
                        onChange={handleChange}
                      />
                    </div>
                    <ErrorText
                      text={formik?.touched?.city && formik?.errors?.city}
                    />
                  </div>

                  <div className="MuiFormControl-root flex-1">
                    <div className="relative">
                      <input
                        type="text"
                        id="floating_outlined"
                        className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                        placeholder=" "
                        name="location"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.location}
                      />
                      <label
                        for="floating_outlined"
                        className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                      >
                        Location
                      </label>
                    </div>
                    <ErrorText
                      text={
                        formik?.touched?.location && formik?.errors?.location
                      }
                    />
                  </div>
                </div>
                <div className="flex gap-4">
                  <div className="MuiFormControl-root MuiTextField-root flex-1">
                    <div className="relative">
                      <input
                        type="text"
                        id="floating_outlined"
                        className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                        placeholder=" "
                        name="pickAddress"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.pickAddress}
                      />
                      <label
                        for="floating_outlined"
                        className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                      >
                        Pickup Address*
                      </label>
                    </div>
                    <ErrorText
                      text={
                        formik?.touched?.pickAddress &&
                        formik?.errors?.pickAddress
                      }
                    />
                  </div>
                </div>
                <div className="flex gap-4">
                  <div className="MuiFormControl-root MuiTextField-root flex-1">
                    <div className="relative">
                      <input
                        type="number"
                        id="floating_outlined"
                        className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                        placeholder=" "
                        name="compNum"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.compNum}
                      />
                      <label
                        for="floating_outlined"
                        className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                      >
                        Company Ph#*
                      </label>
                    </div>
                    <ErrorText
                      text={formik?.touched?.compNum && formik?.errors?.compNum}
                    />
                  </div>
                  <div className="MuiFormControl-root MuiTextField-root flex-1">
                    <div className="relative">
                      <input
                        type="number"
                        id="floating_outlined"
                        className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                        placeholder=" "
                        name="mobNum"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.mobNum}
                      />
                      <label
                        for="floating_outlined"
                        className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                      >
                        Mobile Number*
                      </label>
                    </div>
                    <ErrorText
                      text={formik?.touched?.mobNum && formik?.errors?.mobNum}
                    />
                  </div>
                </div>
                <div className="sm:flex grid gap-4">
                  <div className="MuiFormControl-root MuiTextField-root flex-1">
                    <div className="relative">
                      <input
                        type="number"
                        id="floating_outlined"
                        className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                        placeholder=" "
                        name="mobNum2"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.mobNum2}
                      />
                      <label
                        for="floating_outlined"
                        className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                      >
                        Mobile Number 2
                      </label>
                    </div>
                    <ErrorText
                      text={formik?.touched?.mobNum2 && formik?.errors?.mobNum2}
                    />
                  </div>
                  <div className="MuiFormControl-root MuiTextField-root flex-1">
                    <div className="relative">
                      <input
                        type="text"
                        id="floating_outlined"
                        className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                        placeholder=" "
                        name="compEmail"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.compEmail}
                      />
                      <label
                        for="floating_outlined"
                        className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                      >
                        Company Email*
                      </label>
                    </div>
                    <ErrorText
                      text={
                        formik?.touched?.compEmail && formik?.errors?.compEmail
                      }
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="flex flex-col gap-4">
              <p className="mt-2 mb-[-1rem] text-lg">Selling Medium</p>
              <div className="MuiFormGroup-root MuiFormGroup-row mt-[1rem]">
                <div className="sm:flex">
                  <div className="flex">
                    <div className="flex items-center">
                      <FormControlLabel
                        control={
                          <Checkbox
                            onChange={formik?.handleChange}
                            name="facebook"
                            value={formik?.values.facebook}
                            sx={{
                              "&.Mui-checked": { color: red[600] },
                            }}
                          />
                        }
                        label={<p className="text-sm">Facebook</p>}
                      />
                    </div>
                    <div className="flex items-center">
                      <FormControlLabel
                        control={
                          <Checkbox
                            onChange={formik?.handleChange}
                            name="whatsapp"
                            value={formik?.values.whatsapp}
                            sx={{
                              "&.Mui-checked": { color: red[600] },
                            }}
                          />
                        }
                        label={<p className="text-sm">WhatsApp</p>}
                      />
                    </div>
                  </div>
                  <div className="flex">
                    <div className="flex items-center">
                      <FormControlLabel
                        control={
                          <Checkbox
                            onChange={formik?.handleChange}
                            name="website"
                            value={formik?.values.website}
                            sx={{
                              "&.Mui-checked": { color: red[600] },
                            }}
                          />
                        }
                        label={<p className="text-sm">Website</p>}
                      />
                    </div>

                    <div className="flex items-center">
                      <FormControlLabel
                        control={
                          <Checkbox
                            onChange={formik?.handleChange}
                            name="instagram"
                            value={formik?.values.instagram}
                            sx={{
                              "&.Mui-checked": { color: red[600] },
                            }}
                          />
                        }
                        label={<p className="text-sm">Instagram</p>}
                      />
                    </div>
                  </div>

                  <div className="flex items-center mr-4">
                    <FormControlLabel
                      control={
                        <Checkbox
                          onChange={formik?.handleChange}
                          name="other"
                          value={formik?.values.other}
                          sx={{
                            "&.Mui-checked": { color: red[600] },
                          }}
                        />
                      }
                      label={<p className="text-sm">Others</p>}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="flex gap-4"></div>
            <div className="sm:flex grid gap-4">
              <div className="MuiFormControl-root MuiTextField-root flex-1">
                <div className="relative">
                  <input
                    type="text"
                    id="floating_outlined"
                    className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                    placeholder=" "
                    name="bussinessName"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.bussinessName}
                  />
                  <label
                    for="floating_outlined"
                    className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                  >
                    Bussiness Name*
                  </label>
                </div>
                <ErrorText
                  text={
                    formik?.touched?.bussinessName &&
                    formik?.errors?.bussinessName
                  }
                />
              </div>
              <div className="MuiFormControl-root MuiTextField-root flex-1">
                <div className="relative">
                  <input
                    type="text"
                    id="floating_outlined"
                    className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                    placeholder=" "
                    name="bussinessNature"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.bussinessNature}
                  />
                  <label
                    for="floating_outlined"
                    className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                  >
                    Nature of Bussiness*
                  </label>
                </div>
                <ErrorText
                  text={
                    formik?.touched?.bussinessNature &&
                    formik?.errors?.bussinessNature
                  }
                />
              </div>
            </div>

            <div className="sm:flex grid gap-4">
              <div className="MuiFormControl-root MuiTextField-root flex-1">
                <div className="relative">
                  <input
                    type="text"
                    id="floating_outlined"
                    className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                    placeholder=" "
                    name="billAddress"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.billAddress}
                  />
                  <label
                    for="floating_outlined"
                    className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                  >
                    Billing Address*
                  </label>
                </div>
                <ErrorText
                  text={
                    formik?.touched?.billAddress && formik?.errors?.billAddress
                  }
                />
              </div>
              <div className="MuiFormControl-root MuiTextField-root flex-1">
                <div className="relative">
                  <input
                    type="text"
                    id="floating_outlined"
                    className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                    placeholder=" "
                    name="salesTax"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.salesTax}
                  />
                  <label
                    for="floating_outlined"
                    className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                  >
                    Sales Tax*
                  </label>
                </div>
                <ErrorText
                  text={formik?.touched?.salesTax && formik?.errors?.salesTax}
                />
              </div>
            </div>
            <div className="flex gap-4">
              <div className="flex-1 flex flex-col mt-2">
                <fieldset className="MuiFormControl-root">
                  <p className="mt-2  text-lg">Months into Bussiness</p>
                  <div
                    className="MuiFormGroup-root rowflex mt-[1rem]"
                    role="radiogroup"
                    aria-label="bussinessType"
                  >
                    <div className="flex">
                      <div className="flex items-center mr-4">
                        <RadioGroup
                          className="rowflex"
                          aria-labelledby="bussinessType"
                          defaultValue="female"
                          name="monthsInBussiness"
                          onChange={formik?.handleChange}
                        >
                          <FormControlLabel
                            value="Nill"
                            checked={
                              formik?.values?.monthsInBussiness === "Nill"
                            }
                            control={
                              <Radio
                                sx={{
                                  "&.Mui-checked": {
                                    color: red[600],
                                  },
                                }}
                              />
                            }
                            label={<p className="text-sm">Nil</p>}
                          />

                          <FormControlLabel
                            value="Less than 6 months"
                            checked={
                              formik?.values?.monthsInBussiness ===
                              "Less than 6 months"
                            }
                            control={
                              <Radio
                                sx={{ "&.Mui-checked": { color: red[600] } }}
                              />
                            }
                            label={
                              <p className="text-sm">Less than 6 months</p>
                            }
                          />

                          <FormControlLabel
                            value="Less than a year"
                            checked={
                              formik?.values?.monthsInBussiness ===
                              "Less than a year"
                            }
                            control={
                              <Radio
                                sx={{ "&.Mui-checked": { color: red[600] } }}
                              />
                            }
                            label={<p className="text-sm">Less than a year</p>}
                          />
                        </RadioGroup>
                      </div>
                    </div>
                  </div>
                </fieldset>
              </div>
            </div>
            <div className="flex gap-4">
              <div className="flex-1 flex flex-col mt-2">
                <fieldset className="MuiFormControl-root">
                  <p className="mt-2  text-lg">Average Shipments/Week</p>
                  <div
                    className="MuiFormGroup-root rowflex mt-[1rem]"
                    role="radiogroup"
                    aria-label="bussinessType"
                  >
                    <div className="flex">
                      <div className="flex items-center mr-4">
                        <RadioGroup
                          className="rowflex"
                          aria-labelledby="bussinessType"
                          defaultValue="female"
                          name="avgShip"
                          onChange={formik?.handleChange}
                        >
                          <FormControlLabel
                            value="Nill"
                            checked={formik?.values?.avgShip === "Nill"}
                            control={
                              <Radio
                                sx={{
                                  "&.Mui-checked": {
                                    color: red[600],
                                  },
                                }}
                              />
                            }
                            label={<p className="text-sm">Nil</p>}
                          />

                          <FormControlLabel
                            value="Below 25"
                            checked={formik?.values?.avgShip === "Below 25"}
                            control={
                              <Radio
                                sx={{ "&.Mui-checked": { color: red[600] } }}
                              />
                            }
                            label={<p className="text-sm">Below 25</p>}
                          />

                          <FormControlLabel
                            value="Above 25"
                            checked={formik?.values?.avgShip === "Above 25"}
                            control={
                              <Radio
                                sx={{ "&.Mui-checked": { color: red[600] } }}
                              />
                            }
                            label={<p className="text-sm">Above 25</p>}
                          />
                        </RadioGroup>
                      </div>
                    </div>
                  </div>
                </fieldset>
              </div>
            </div>
            <div className="flex flex-col gap-1">
              <p className="mt-2  text-lg">Contact Person</p>
              <div className="sm:flex grid gap-4 ">
                <div className="MuiFormControl-root MuiTextField-root flex-1">
                  <div className="relative">
                    <input
                      type="number"
                      id="floating_outlined"
                      className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                      placeholder=" "
                      name="serialNum"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.serialNum}
                    />
                    <label
                      for="floating_outlined"
                      className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                    >
                      Serial Number*
                    </label>
                  </div>
                  <ErrorText
                    text={
                      formik?.touched?.serialNum && formik?.errors?.serialNum
                    }
                  />
                </div>
                <div className="MuiFormControl-root MuiTextField-root flex-1">
                  <div className="relative">
                    <input
                      type="text"
                      id="floating_outlined"
                      className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                      placeholder=" "
                      name="name"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.name}
                    />
                    <label
                      for="floating_outlined"
                      className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                    >
                      Name*
                    </label>
                  </div>
                  <ErrorText
                    text={formik?.touched?.name && formik?.errors?.name}
                  />
                </div>
              </div>
              <div className="sm:flex grid gap-4">
                <div className="MuiFormControl-root MuiTextField-root flex-1">
                  <div className="relative">
                    <input
                      type="text"
                      id="floating_outlined"
                      className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                      placeholder=" "
                      name="designation"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.designation}
                    />
                    <label
                      for="floating_outlined"
                      className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                    >
                      Designation*
                    </label>
                  </div>
                  <ErrorText
                    text={
                      formik?.touched?.designation &&
                      formik?.errors?.designation
                    }
                  />
                </div>
                <div className="MuiFormControl-root MuiTextField-root flex-1">
                  <div className="relative">
                    <input
                      type="text"
                      id="floating_outlined"
                      className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                      placeholder=" "
                      name="custMobNum"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.custMobNum}
                    />
                    <label
                      for="floating_outlined"
                      className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                    >
                      Mobile*
                    </label>
                  </div>
                  <ErrorText
                    text={
                      formik?.touched?.custMobNum && formik?.errors?.custMobNum
                    }
                  />
                </div>
              </div>
              <div className="sm:flex grid gap-4">
                <div className="MuiFormControl-root MuiTextField-root flex-1">
                  <div className="relative">
                    <input
                      type="text"
                      id="floating_outlined"
                      className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                      placeholder=" "
                      name="custEmail"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.custEmail}
                    />
                    <label
                      for="floating_outlined"
                      className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                    >
                      Email*
                    </label>
                  </div>
                  <ErrorText
                    text={
                      formik?.touched?.custEmail && formik?.errors?.custEmail
                    }
                  />
                </div>
                <div className="MuiFormControl-root MuiTextField-root flex-1">
                  <div className="relative">
                    <input
                      type="text"
                      id="floating_outlined"
                      className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                      placeholder=" "
                      name="custCNIC"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.custCNIC}
                    />
                    <label
                      for="floating_outlined"
                      className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                    >
                      CNIC*
                    </label>
                  </div>
                  <ErrorText
                    text={formik?.touched?.custCNIC && formik?.errors?.custCNIC}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="sm:flex block flex-col justify-center items-center mt-[1rem] ">
          <div className="flex flex-col gap-3 p-8 shadow-card text-sm  md:w-[45rem] sm:w-[40rem] w-[auto] mx-[1rem] rounded-md transition-all duration-500">
            <h2 className="font-bold text-[1.1rem]">Product Range</h2>
            <div className="flex gap-4">
              <div className="flex-1 flex flex-col">
                <p>Please select atleast one product</p>
                <div className="MuiFormGroup-root MuiFormGroup-row">
                  <div className="flex flex-col sm:flex-row">
                    <div className="flex-1 flex flex-col">
                      <div className="flex items-center ">
                        <FormControlLabel
                          control={
                            <Checkbox
                              name="Clothing"
                              onChange={handleProdChange}
                              sx={{
                                "                         &.Mui-checked": {
                                  color: red[600],
                                },
                              }}
                            />
                          }
                          label={<p className="text-sm">Clothing</p>}
                        />
                      </div>
                      <div className="flex items-center">
                        <FormControlLabel
                          control={
                            <Checkbox
                              name="Books"
                              onChange={handleProdChange}
                              sx={{
                                "&.Mui-checked": { color: red[600] },
                              }}
                            />
                          }
                          label={<p className="text-sm">Books</p>}
                        />
                      </div>

                      <div className="flex items-center">
                        <FormControlLabel
                          control={
                            <Checkbox
                              name="Watches"
                              onChange={handleProdChange}
                              sx={{
                                "&.Mui-checked": { color: red[600] },
                              }}
                            />
                          }
                          label={<p className="text-sm">Watches</p>}
                        />
                      </div>

                      <div className="flex items-center">
                        <FormControlLabel
                          control={
                            <Checkbox
                              name="Perfumes and Cosmetics"
                              onChange={handleProdChange}
                              sx={{
                                "&.Mui-checked": { color: red[600] },
                              }}
                            />
                          }
                          label={
                            <p className="text-sm">Perfumes and Cosmetics</p>
                          }
                        />
                      </div>

                      <div className="flex items-center">
                        <FormControlLabel
                          control={
                            <Checkbox
                              name="Sports"
                              onChange={handleProdChange}
                              sx={{
                                "&.Mui-checked": { color: red[600] },
                              }}
                            />
                          }
                          label={<p className="text-sm">Sports</p>}
                        />
                      </div>
                    </div>

                    <div className="flex-1 flex flex-col">
                      <div className="flex items-center">
                        <FormControlLabel
                          control={
                            <Checkbox
                              name="Home Decor"
                              onChange={handleProdChange}
                              sx={{
                                "&.Mui-checked": { color: red[600] },
                              }}
                            />
                          }
                          label={<p className="text-sm">Home Decor</p>}
                        />
                      </div>

                      <div className="flex items-center">
                        <FormControlLabel
                          control={
                            <Checkbox
                              name="Home Appliances"
                              onChange={handleProdChange}
                              sx={{
                                "&.Mui-checked": { color: red[600] },
                              }}
                            />
                          }
                          label={<p className="text-sm">Home Appliances</p>}
                        />
                      </div>

                      <div className="flex items-center ">
                        <FormControlLabel
                          control={
                            <Checkbox
                              name="Health and Fitness"
                              onChange={handleProdChange}
                              sx={{
                                "&.Mui-checked": { color: red[600] },
                              }}
                            />
                          }
                          label={<p className="text-sm">Health and Fitness</p>}
                        />
                      </div>

                      <div className="flex items-center ">
                        <FormControlLabel
                          control={
                            <Checkbox
                              name="Mobile and Tablets (PTA Approved)"
                              onChange={handleProdChange}
                              sx={{
                                "&.Mui-checked": { color: red[600] },
                              }}
                            />
                          }
                          label={
                            <p className="text-sm">
                              Mobile and Tablets (PTA Approved)
                            </p>
                          }
                        />
                      </div>

                      <div className="flex items-center mb-3">
                        <FormControlLabel
                          control={
                            <Checkbox
                              name="Computer, Peripherals and Accessories"
                              onChange={handleProdChange}
                              sx={{
                                "&.Mui-checked": { color: red[600] },
                              }}
                            />
                          }
                          label={
                            <p className="text-sm">
                              Computer, Peripherals and Accessories
                            </p>
                          }
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="flex-1 flex flex-col">
              <div className="MuiFormControl-root MuiTextField-root flex-1">
                <div className="relative">
                  <input
                    type="text"
                    id="floating_outlined"
                    className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                    placeholder=" "
                    onChange={(e) =>
                      formik?.setFieldValue("prodRange", {
                        ...formik?.values?.prodRange,
                        other: e?.target?.value,
                      })
                    }
                    name="prodRange"
                    onBlur={formik.handleBlur}
                    value={formik.values.prodRange?.other}
                  />

                  <label
                    for="floating_outlined"
                    className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                  >
                    Other (Please Specify)
                  </label>
                </div>
                <ErrorText
                  text={formik?.touched?.prodRange && formik?.errors?.prodRange}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="sm:flex block flex-col justify-center items-center mt-[1rem] ">
        <div className="flex flex-col gap-1 p-8 shadow-card text-sm  md:w-[45rem] sm:w-[40rem] w-[auto] mx-[1rem] rounded-md transition-all duration-500">
          <h2 className="font-bold text-[1.1rem]">Rates &amp; Acceptance</h2>
          <div className="flex gap-4">
            <div className="flex-1 flex flex-col">
              <div className="sm:flex grid gap-[0.1rem]">
                <div className="bg-[#f21e26] text-white rounded-l-md h-[2.5rem] flex-1 flex justify-center items-center">
                  Upto 1 kg &amp; each additional kg
                </div>
                <div className="bg-[#f21e26] text-white rounded-r-md h-[2.5rem] flex-1 flex justify-center items-center">
                  Destination
                </div>
              </div>
              <table className="mt-6">
                <thead>
                  <tr className="text-left bg-gray-100">
                    <th className="border p-2">Origin</th>
                    <th className="border p-2">South</th>
                    <th className="border p-2">Central</th>
                    <th className="border p-2">North</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="border p-2">South</td>
                    <td className="border p-2">160</td>
                    <td className="border p-2">240</td>
                    <td className="border p-2">250</td>
                  </tr>
                  <tr>
                    <td className="border p-2">Central</td>
                    <td className="border p-2">240</td>
                    <td className="border p-2">160</td>
                    <td className="border p-2">180</td>
                  </tr>
                  <tr>
                    <td className="border p-2">North</td>
                    <td className="border p-2">250</td>
                    <td className="border p-2">180</td>
                    <td className="border p-2">160</td>
                  </tr>
                  <tr>
                    <td className="border p-2">Within City</td>
                    <td className="border p-2">120</td>
                    <td className="border p-2"></td>
                    <td className="border p-2"></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div className="flex gap-4 mt-4">
            <div className="flex-1 flex flex-col">
              <div className="sm:flex grid gap-[0.1rem]">
                <div className="bg-[#f21e26] text-white rounded-l-md h-[2.5rem] flex-1 flex justify-center items-center">
                  Upto 0.5 kg
                </div>
                <div className="bg-[#f21e26] text-white rounded-r-md h-[2.5rem] flex-1 flex justify-center items-center">
                  Destination
                </div>
              </div>
              <table className="mt-6">
                <thead>
                  <tr className="text-left bg-gray-100">
                    <th className="border p-2">Origin</th>
                    <th className="border p-2">South</th>
                    <th className="border p-2">Central</th>
                    <th className="border p-2">North</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="border p-2">South</td>
                    <td className="border p-2">160</td>
                    <td className="border p-2">190</td>
                    <td className="border p-2">190</td>
                  </tr>
                  <tr>
                    <td className="border p-2">Central</td>
                    <td className="border p-2">180</td>
                    <td className="border p-2">250</td>
                    <td className="border p-2">160</td>
                  </tr>
                  <tr>
                    <td className="border p-2">North</td>
                    <td className="border p-2">190</td>
                    <td className="border p-2">160</td>
                    <td className="border p-2">150</td>
                  </tr>
                  <tr>
                    <td className="border p-2">Within City</td>
                    <td className="border p-2">110</td>
                    <td className="border p-2"></td>
                    <td className="border p-2"></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div className="flex gap-4 mt-4">
            <div className="flex-1 flex flex-col"></div>
          </div>
          <div className="sm:flex grid gap-4">
            <div className="flex-1 flex flex-col">
              <button className="text-white bg-[#D40511] border border-[#F21E26] w-full rounded-md mt-1 p-1 h-[2.5rem] text-sm hover:bg-[#F21E26] hover:text-white transition-all duration-500">
                Accept
              </button>
            </div>
            <div className="flex-1 flex flex-col w-full text-right justify-center">
              For Any Query{" "}
              <span
                onClick={handleClickOpen}
                className="text-[#D40511] font-semibold cursor-pointer"
              >
                Click Here!
              </span>
            </div>
          </div>
          <div className="flex gap-4">
            <div className="flex-1 flex flex-col">
              <p className="mt-2 mb-[-1rem] text-lg">
                Bank Account Details for IBFT
              </p>
            </div>
          </div>
          <div className="sm:flex grid gap-4 mt-4">
            <div className="MuiFormControl-root MuiTextField-root flex-1">
              <div className="relative">
                <input
                  type="Number"
                  id="floating_outlined"
                  className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                  placeholder=" "
                  name="iban"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.iban}
                />

                <label
                  for="floating_outlined"
                  className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                >
                  IBAN #
                </label>
              </div>
              <ErrorText text={formik?.touched?.iban && formik?.errors?.iban} />
            </div>
            <div className="MuiFormControl-root MuiTextField-root flex-1">
              <div className="relative">
                <input
                  type="Number"
                  id="floating_outlined"
                  className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                  placeholder=" "
                  name="bankName"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.bankName}
                />

                <label
                  for="floating_outlined"
                  className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                >
                  Bank Name
                </label>
              </div>
              <ErrorText
                text={formik?.touched?.bankName && formik?.errors?.bankName}
              />
            </div>
          </div>
          <div className="sm:flex grid gap-4 ">
            <div className="MuiFormControl-root MuiTextField-root flex-1">
              <div className="relative">
                <input
                  type="Number"
                  id="floating_outlined"
                  className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                  placeholder=" "
                  name="branch"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.branch}
                />

                <label
                  for="floating_outlined"
                  className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                >
                  Branch
                </label>
              </div>
              <ErrorText
                text={formik?.touched?.branch && formik?.errors?.branch}
              />
            </div>
            <div className="MuiFormControl-root MuiTextField-root flex-1">
              <div className="relative">
                <input
                  type="Number"
                  id="floating_outlined"
                  className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                  placeholder=" "
                  name="bankAcTitle"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.bankAcTitle}
                />

                <label
                  for="floating_outlined"
                  className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                >
                  Bank A/C Title
                </label>
              </div>
              <ErrorText
                text={
                  formik?.touched?.bankAcTitle && formik?.errors?.bankAcTitle
                }
              />
            </div>
          </div>
        </div>
        <div className="sm:flex block flex-col justify-center items-center mt-[1rem] ">
          <div className="flex flex-col gap-3 p-8 shadow-card text-sm  md:w-[45rem] sm:w-[40rem] w-[auto] mx-[1rem] rounded-md transition-all duration-500">
            <h2 className="font-bold text-[1.1rem]">Terms &amp; Conditions</h2>
            <div className="flex gap-4">
              <div className="flex-1 flex flex-col">
                <div className="MuiFormGroup-root">
                  <div className="flex items-center mr-4">
                    <FormControlLabel
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      checked={formik.values.termCond}
                      name="termCond"
                      control={
                        <Checkbox
                          sx={{ "&.Mui-checked": { color: red[600] } }}
                        />
                      }
                      label={
                        <p className="text-sm">
                          I have read and hereby accept the{" "}
                          <a
                            rel="noopener noreferrer"
                            target="_blank"
                            href="https://customeraccount.tcscourier.com/accountopening/TermsAndCond.aspx"
                            className="text-[#337ab7]"
                          >
                            Terms and Conditions
                          </a>
                        </p>
                      }
                    />
                  </div>
                  <ErrorText
                    text={formik?.touched?.termCond && formik?.errors?.termCond}
                  />

                  <div className="flex items-center mt-0">
                    <FormControlLabel
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      checked={formik.values.undertak}
                      name="undertak"
                      control={
                        <Checkbox
                          sx={{ "&.Mui-checked": { color: red[600] } }}
                        />
                      }
                      label={
                        <p className="text-sm">
                          I have read and hereby accept the{" "}
                          <a
                            rel="noopener noreferrer"
                            target="_blank"
                            href="https://customeraccount.tcscourier.com/accountopening/RegUndertaking.aspx"
                            className="text-[#337ab7]"
                          >
                            Undertaking
                          </a>
                        </p>
                      }
                    />
                  </div>
                  <ErrorText
                    text={formik?.touched?.undertak && formik?.errors?.undertak}
                  />
                </div>
              </div>
            </div>
            <div className="flex gap-4">
              <div className="flex-1 flex flex-col"></div>
            </div>
          </div>
        </div>
        <div className="flex flex-col justify-left mt-[1rem] mb-[0.6rem] mx-[1rem]">
          <div className="flex gap-4 md:w-[45rem] sm:w-[40rem] w-[18.5rem]">
            <div className="g-recaptcha">
              <ReCAPTCHA
                // sitekey="6Le3utQhAAAAAOvAHs5QXdniSKLmvtTn0vM7GUzA"
                // sitekey="6LeQwecjAAAAACyoUlVWbSpm-LaXakw8mAyWNfM6"
                // sitekey="6LfkXRwlAAAAAI8Irv8mXsI4dcJ5md35PHtInHFJ"
                sitekey={process.env.REACT_APP_CAPTCH}
                // sitekey="6Lf3Eh0lAAAAACIaOrGsuJqodVFcohx81VLCwm3k"
                onChange={(value) => {
                  console.log("Captcha value:", value);
                  formik.setFieldValue("recaptcha", value);
                }}
              />
            </div>
          </div>
        </div>
        <button
          onClick={formik?.handleSubmit}
          type="submit"
          className=" text-white bg-[#D40511] border border-[#F21E26] md:w-[45rem] sm:w-[40rem] w-[17rem] sm:ml-0 ml-6 rounded-md mt-1 mb-6 p-1 h-[2.5rem] text-sm hover:bg-[#F21E26] hover:text-white transition-all duration-500"
        >
          Submit
        </button>
      </div>

      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
      >
        <BootstrapDialogTitle
          id="customized-dialog-title"
          onClose={handleClose}
        >
          <div className="pb-[1rem]">Enter Query</div>
        </BootstrapDialogTitle>

        <div className="w-[30rem] pt-2 pb-1 pl-2">
          <h1>Enter Query</h1>
          <div className="flex w-full pt-2 pb-2">
            <div className="relative w-[30rem] ">
              <input
                type="text"
                rows="4rem"
                id="floating_outlined"
                className="row-5 block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                placeholder=" "
              />
              <label
                for="floating_outlined"
                rows="4"
                className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
              >
                Customer Name/Account Title
              </label>
            </div>
          </div>

          <div className="flex p-[1rem] justify-end ">
            <div className="mr-[1rem]">
              <Button variant="outlined">Text</Button>
            </div>

            <div>
              <Button variant="contained" color="error">
                Submit1
              </Button>
            </div>
          </div>
        </div>
        {/* </Modal> */}
      </BootstrapDialog>

      <div
        ref={modalRef}
        // style={backdropStyle}
        className={`${styles.modal__wrap}`}
        onClick={() => setShow(false)}
      >
        <div
          className={`flex flex-col justify-center items-center ${styles.modal}`}
        >
          <div className="bg-white w-full h-[106%] relative z-[1000] rounded-3xl">
            <div className="flex justify-center items-center">
              <img
                src="/popup-circle.png"
                alt=""
                className="mx-auto w-[12.5rem]"
              />
              <img
                src="/popup-icon.png"
                alt=""
                className="absolute top-[-3.5rem] mx-auto w-[7rem]"
              />
            </div>
            <div className="absolute right-[1rem] top-[1rem] ">
              <CloseIcon fontSize="large" style={{ color: "#f21e26" }} />
            </div>
            <div className="flex flex-col text-center justify-center item-center mt-[6rem]">
              <h2 className="font-bold text-xl">Thank you for submitting.</h2>
              <p>We’ll contact you soon.</p>
            </div>
          </div>
          <div className="mx-auto bg-[#ed1d25] w-[80%] h-[2rem] rounded-full mt-[-1.2rem]"></div>
        </div>
      </div>
    </div>
  );
};
export default OpenAccount;

// import { useEffect, useState } from 'react';
// import { useNavigate } from 'react-router-dom';
// import { useCookies } from 'react-cookie'
// import { FormControl, InputLabel, Select } from "@mui/material";
// import MenuItem from "@mui/material/MenuItem";

// const OpenAccount = () => {
//     const [customer, setCustomer] = useState("");
//     const [shipping, setShipping] = useState("");

//     const [selectedDivision, setSelectedDivision] = useState("");
//     const [selectedSubCat, setSelectedSubCat] = useState("");
//     const [product2Dropdown, setProduct2Dropdown] = useState([]);
//     const navigate = useNavigate();
//     const [cookies, setCookie] = useCookies(['prodType', 'subCat'])

//     const handleAccount = () => {
//         if (selectedSubCat ==="Overnight" || selectedSubCat === "2nd Day") navigate("/ecom");
//         else if (selectedDivision === "MMS") navigate("/mmsForm");
//         else if (selectedDivision === "Overland") navigate("/overland");

//     };

//     const [productType, setProductType] = useState({
//       "General": [
//         "Overnight",
//         "2nd Day"
//       ],
//       "Sentiments": [
//         "Products"
//       ],
//       "Overland": [
//         "Overland Express"
//       ]

//     });
//     const productTypeCorp = {

//     };
//     const productTypeEcom = {

//       "General": [
//         "Overnight",
//         "2nd Day"
//       ],
//       "Overland": [
//         "Overland Express"
//       ],
//     };

//     const divisionDropdown = [ 'Ecommerce']

//     const [productDropdown, setProductDropdown] = useState(
//       Object.keys(productTypeCorp)
//     );
//     const productDropdownEcom = Object.keys(productTypeEcom);
//     let [accountProd, setAccountProd] = useState("");

//     const handleProduct = (e) => {
//       console.log(e);
//       e.target.value === "0"
//         ? setProduct2Dropdown([])
//         : setProduct2Dropdown(selectedDivision === 'Corporate' ? productTypeCorp[e.target.value] : productTypeEcom[e.target.value]);
//       setAccountProd(e.target.value);
//     };

//     useEffect(() => {
//       if (customer === "new")
//         document.getElementById('new').scrollIntoView({ block: 'center', behavior: 'smooth' });
//     }, [customer])

//     useEffect(() => {
//       if (shipping)
//         document.getElementById('shipping').scrollIntoView({ block: 'center', behavior: 'smooth' });
//     }, [shipping, selectedDivision])
//     return(
// <>
// <div className="my-[3rem]">

//         <div id='shipping' className="flex flex-col justify-center items-center mt-[1rem] ">
//             <div className="flex flex-col gap-3 p-4 shadow-my-lg text-sm lg:w-[45rem] md:w-[45rem] w-[22rem] rounded-md transition-all duration-500">

//                 <h2 className="font-bold text-[1.1rem]">
//                   Please Select a Product Type
//                 </h2>
//                 <div className="flex gap-4">
//                   <div className="flex-1 flex flex-col">
//                     <FormControl
//                       variant="outlined"
//                       className="flex-1"
//                       size="small"
//                       inputProps={{ style: { fontSize: 14 } }}
//                       InputLabelProps={{ style: { fontSize: 14 } }}
//                     >
//                       <InputLabel
//                         id="demo-simple-select-outlined-label"
//                         style={{ fontSize: "14px !important" }}
//                       >
//                         Product Type
//                       </InputLabel>
//                       <Select
//                         required
//                         labelId="demo-simple-select-outlined-label"
//                         id="demo-simple-select-outlined"

//                         onChange={handleProduct}
//                         label="Product Type"
//                         inputProps={{ style: { fontSize: 14 } }}
//                         InputLabelProps={{ style: { fontSize: 14 } }}
//                       >
//                         {selectedDivision === 'Corporate' ? productDropdown.map((product, index) => (

//                           <MenuItem key={index} value={product} onClick={() => setCookie('prodType', product, { path: '/' })}>
//                             {product}
//                           </MenuItem>
//                         )) : productDropdownEcom.map((product, index) => (

//                           <MenuItem key={index} value={product} onClick={() => setCookie('subCat', product, { path: '/' })}>
//                           {product}
//                           </MenuItem>
//                         ))}
//                       </Select>
//                     </FormControl>
//                   </div>
//                 </div>
//                 <div className="flex gap-4">
//                   <div className="flex-1 flex flex-col">
//                     {product2Dropdown.length !== 0 && (
//                       <FormControl
//                         variant="outlined"
//                         className="flex-1"
//                         size="small"
//                         inputProps={{ style: { fontSize: 14 } }}
//                         InputLabelProps={{ style: { fontSize: 14 } }}
//                       >
//                         <InputLabel
//                           id="demo-simple-select-outlined-label"
//                           style={{ fontSize: "14px !important" }}
//                         >
//                           Subcategory
//                         </InputLabel>
//                         <Select
//                           required
//                           labelId="demo-simple-select-outlined-label"
//                           id="demo-simple-select-outlined"

//                           label="Subcategory"
//                           inputProps={{ style: { fontSize: 14 } }}
//                           InputLabelProps={{ style: { fontSize: 14 } }}
//                         >
//                           {product2Dropdown.map((product, index) => (
//                              <MenuItem key={index} value={product} onClick={() =>
//                               setSelectedSubCat(product)

//                             }>
//                               {product}
//                             </MenuItem>

//                           ))}
//                         </Select>
//                       </FormControl>
//                     )}
//                   </div>
//                 </div>
//               {/* </>} */}
//               <button
//                 onClick={handleAccount}
//                 className="text-white bg-[#D40511] border border-[#F21E26] w-full rounded-md mt-1 p-1 h-[2.5rem] text-sm hover:bg-[#F21E26] hover:text-white transition-all duration-500"
//               >
//                 Open an Account
//               </button>

//             </div>
//           </div>
//           </div>
// </>
//     );
// }
// export default OpenAccount;
